import { useTranslation } from "react-i18next";
import Metre from "../../../../../../components/Math/Units/Metric/Metre";
import Millimetre from "../../../../../../components/Math/Units/Metric/Millimetre";
import { NumberFormatText } from "../../../../../../components/NumberFormatText";
import { RowBody } from "../../../../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../../../../components/ToolTip";

function Halbwellenlaenge({ halbwellenlaenge = 0 }) {
  const { t } = useTranslation("translation");
  const L_Hw_Formula = `\\displaystyle L_{\\tiny _{Hw}} = \\frac{L}{m}`;
  return (
    <RowBody
      titleValue={<p>{t("inner.buckling.ofner.Verification.lengthHalfcycles")}</p>}
      indicesValue={
        <span>
          L<sub>Hw</sub>
        </span>
      }
      formulaValue={
        <>
          <ToolTip id={"L_Hw_Formula"} type={IconType.FORMULA} formula={L_Hw_Formula} />
          <ToolTip
            id={"Halbwellenlaenge"}
            type={IconType.INFO}
            text={t("inner.buckling.ofner.Verification.lengthHalfcycles_SubText")}
          />
        </>
      }
      inputValue={
        <span className="input">
          <NumberFormatText value={halbwellenlaenge} decimalScale={0} />
        </span>
      }
      unitValue={<Millimetre />}
    />
  );
}

export default Halbwellenlaenge;
